import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=57f13a75&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"
import style0 from "./Admin.vue?vue&type=style&index=0&id=57f13a75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.41_css-loader@6.11.0_webpack@5.109.2_clean-css_2948e68b94b5de989bd17d5ad2285242/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f13a75",
  null
  
)

export default component.exports